import React from "react";
import Footer from "../components/Footer";
import SubHeader from "../components/SubHeader";

function Teafactoryvisits() {
  return (
    <>
      <SubHeader />
      <main>
        <section className="page-header">
          <div className="page-header__bg" />
          {/* /.page-header__bg */}
          <div className="container">
            <ul className="villoz-breadcrumb list-unstyled">
              <li>
                <a href="index.html">Home</a>
              </li>
              <li>
                <span>Activities</span>
              </li>
              <li>
                <span>Visits to Tea Factory &amp; Tea Estates</span>
              </li>
            </ul>
            {/* /.thm-breadcrumb list-unstyled */}
            <h2 className="page-header__title">
              Visits to Tea Factory &amp; Tea Estates
            </h2>
          </div>
          {/* /.container */}
        </section>
        {/* /.page-header */}
        <section className="destinations-details">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="destinations-details__image">
                  <img
                    src="assets/images/activities/teafactory/main.webp?v=20260924"
                    alt="villoz"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="destinations-details__content">
                  <h3 className="destinations-details__title">
                    A Visits to Tea Factory &amp; Tea Estates
                  </h3>
                  <p className="destinations-details__text">
                    Immerse yourself in the rich heritage of Sri Lanka’s tea
                    culture with a visit to the Ceylon Tea Museum, and the
                    surrounding tea estates of Hanthana. This experience offers
                    a glimpse into the timeless craft of tea-making, set against
                    the breathtaking backdrop of Hanthana’s rolling hills.
                    <br />
                    <br />
                    Begin your journey at Hanthana House, walking to the Ceylon
                    Tea Museum, housed in a beautifully restored tea factory.
                    Here you’ll explore the history of Ceylon tea, from its
                    colonial roots to its rise as a global icon. The museum
                    exhibits showcase vintage machinery, historic memorabilia
                    and the stories of pioneers who shaped Sri Lanka’s tea
                    industry.
                    <br />
                    <br />
                    Surrounded by lush tea estates, you can wander through
                    emerald-green fields and learn about the day-to-day life of
                    tea pluckers. The peaceful ambiance of the estates, combined
                    with the cool mountain air, makes this a truly refreshing
                    and rejuvenating experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="gallery-three">
          <div className="container">
            <div
              className="gallery-three__carousel villoz-owl__carousel  villoz-owl__carousel--basic-nav owl-carousel owl-theme"
              data-owl-options='{
			"items": 5,
			"margin": 30,
			"loop": false,
			"smartSpeed": 700,
			"nav": false,
			"navText": ["<span class=\"fa fa-angle-left\"></span>","<span class=\"fa fa-angle-right\"></span>"],
			"dots": false,
			"autoplay": true,
			"responsive": {
				"0": {
					"items": 1
				},
				"360": {
					"items": 2,
					"margin": 20
				},
				"575": {
					"items": 3
				},
				"992": {
					"items": 4
				},
				"1200": {
              "margin": 42,
					"items": 5
				}
			}
			}'
            >
              <div className="item">
                <div className="gallery-three__card">
                  <img src="assets/images/activities/teafactory/1.jpg?v=20260924" alt="" />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/teafactory/1.jpg?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
              <div className="item">
                <div className="gallery-three__card">
                  <img src="assets/images/activities/teafactory/2.jpg?v=20260924" alt="" />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/teafactory/2.jpg?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
              <div className="item">
                <div className="gallery-three__card">
                  <img src="assets/images/activities/teafactory/3.jpg?v=20260924" alt="" />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/teafactory/3.jpg?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
              <div className="item">
                <div className="gallery-three__card">
                  <img src="assets/images/activities/teafactory/4.jpg?v=20260924" alt="" />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/teafactory/4.jpg?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
              <div className="item">
                <div className="gallery-three__card">
                  <img src="assets/images/activities/teafactory/5.jpg?v=20260924" alt="" />
                  <div className="gallery-three__card__hover">
                    <a
                      href="assets/images/activities/teafactory/5.jpg?v=20260924"
                      className="img-popup"
                    >
                      <span className="gallery-three__card__icon" />
                    </a>
                  </div>
                  {/* /.gallery-three__card__hover */}
                </div>
                {/* /.gallery-three__card */}
              </div>
              {/* /.col-md-6 col-lg-4 */}
            </div>
            {/* /.gallery-three__carousel */}
          </div>
          {/* /.container */}
        </section>
        {/* /.gallery-three */}
      </main>
      <Footer />
    </>
  );
}

export default Teafactoryvisits;
